import {ElasticParser, ElasticSearchProperty} from '../factory.parsers';
import moment from 'moment';
import {buildQueryLessEqual} from '../../query/elastic.queries';

export class PublicDataParser implements ElasticParser {
  parseValue(publicData: boolean, elasticSearchProperty: ElasticSearchProperty): any {
    if (publicData === true) {
      const {property} = elasticSearchProperty;
      const now = moment().format('YYYY-MM-DD');
      return buildQueryLessEqual(property, now);
    } else {
      return undefined;
    }
  }
}
